import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface DiagnosesCountByRegionIdResponse {
  region_id: number
  demand_count_by_field: Record<string, number>
}

export async function getDiagnosesCountByRegionId(
  id: number,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<DiagnosesCountByRegionIdResponse>(
    apiRoutes.getDiagnosesCountByRegionId(id),
    options,
  )

  return data
}
